export const reduceAlertsToDateRange = (alerts: any, rangeSetting: number) => {
  const now = Math.floor(Date.now() / 1000)
  const start = now - rangeSetting;

  return alerts.reduce((acc: any[], alert: any) => {
    if(alert.time > start && alert.time <= now) {
      acc.push(alert);
    }
    return acc;
  }, [])
}






// WEBPACK FOOTER //
// ./src/utils/alerts/reduceAlertsToDateRange.ts